import { Inject, Injectable, Optional, Type } from '@angular/core';
import {AI_APP_EVENT_RENDERERS, AiAppEventRendererComponent} from "./aiAppEventRenderer.service";

@Injectable()
export class AiAppEventRendererRegistry {
    private readonly renderers = new Map<string, Type<AiAppEventRendererComponent>>();

    constructor(
        @Optional()
        @Inject(AI_APP_EVENT_RENDERERS)
            rendererComponents: Array<Type<AiAppEventRendererComponent> & { eventName: string }> | null
    ) {
        for (const component of rendererComponents ?? []) {
            this.renderers.set(component.eventName, component);
        }
    }

    getComponent(eventName: string): Type<AiAppEventRendererComponent> | null {
        return this.renderers.get(eventName) ?? null;
    }
}